var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"mobilepreview"}},[_c('div',{staticStyle:{"margin":"20px","background":"#e8e8ff"}},[_c('loading',{attrs:{"active":_vm.isLoading,"can-cancel":false,"loader":"dots","color":"#007bff","height":45,"width":75,"is-full-page":_vm.fullPage},on:{"update:active":function($event){_vm.isLoading=$event}}}),(
        _vm.imagelist[0].file_type == 'jpeg' ||
        _vm.imagelist[0].file_type == 'jpg' ||
        _vm.imagelist[0].file_type == 'png' ||
        _vm.imagelist[0].file_type == 'gif' ||
        _vm.imagelist[0].file_type == 'image'
      )?_c('div',[_c('img',{staticStyle:{"marging":"5px","padding":"8px","cursor":"pointer"},attrs:{"src":_vm.imagelist[0].downlaod_url}})]):_vm._e(),(
        _vm.imagelist[0].file_type == 'mpeg-4' ||
        _vm.imagelist[0].file_type == 'mp4' ||
        _vm.imagelist[0].file_type == 'video'
      )?_c('div',[_c('video',{attrs:{"width":"500","height":"300","align":"left","controls":"","src":_vm.imagelist[0].downlaod_url}})]):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }